/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";

import postImg1 from "../../assets/img/blog/details-sm-1.jpg";
import postImg2 from "../../assets/img/blog/details-sm-2.jpg";
import postImg3 from "../../assets/img/blog/details-sm-3.jpg";

const Sidebar = () => {
  const posts = [
    {
      id: 1,
      postImage: postImg1,
      publishedDate: "06-02-2024",
      postTitle: " Lorem ipsum dolor ameting elit sedness.",
    },
    {
      id: 2,
      postImage: postImg2,
      publishedDate: "16-08-2024",
      postTitle: " Lorem ipsum dolor ameting elit sedness.",
    },
    {
      id: 3,
      postImage: postImg3,
      publishedDate: "08-08-2022",
      postTitle: " Lorem ipsum dolor ameting elit sedness.",
    },
  ];

  return (
    <div className="sidebar-right">
      <div className="sidebar-widget mb-45">
        <h4 className="sidebar-widget-title mb-35">Search Here</h4>
        <div className="sidebar-search-box p-relative">
          <div className="sidebar-search-input">
            <input type="text" placeholder="Search here" />
          </div>
          <div className="sidebar-search-button">
            <button type="submit">
              <i className="flaticon-next"></i>
            </button>
          </div>
        </div>
      </div>
      <div className="sidebar-widget mb-45">
        <h4 className="sidebar-widget-title mb-40">Services list</h4>
        <div className="sidebar-widget-list">
          <Link to="/blog-details">
            <i className="flaticon-next"></i>Plastics Surgery
          </Link>
          <Link className="active" to="/blog-details">
            <i className="flaticon-next"></i>Hematology
          </Link>
          <Link to="/blog-details">
            <i className="flaticon-next"></i>Neurology
          </Link>
          <Link to="/blog-details">
            <i className="flaticon-next"></i>Gastrologic
          </Link>
          <Link to="/blog-details">
            <i className="flaticon-next"></i>Orthopedic
          </Link>
        </div>
      </div>
      <div className="sidebar-widget mb-45">
        <h4 className="sidebar-widget-title mb-40">Recent post:</h4>
        <div className="sidebar-widget-content">
          <div className="sidebar-widget-post">
            {posts.map((post) => (
              <div key={post.id} className="rc-post mb-15 d-flex align-items-center">
                <div className="rc-post-thumb mr-20">
                  <Link to="/blog-details">
                    <img src={post.postImage} alt="" />
                  </Link>
                </div>
                <div className="rc-post-content">
                  <h3 className="rc-post-title mb-15">
                    <Link to="/blog-details">{post.postTitle}</Link>
                  </h3>
                  <div className="rc-meta d-flex">
                    <i className="flaticon-calendar"></i>
                    <span>{post.publishedDate}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="sidebar-widget">
        <div className="sideba-widge-title-box">
          <h3 className="sidebar-widget-title sm-border mb-35">Popular Tag</h3>
        </div>
        <div className="sidebar-widget-content">
          <div className="tagcloud">
            <a href="#">Medical</a>
            <a href="#">Health care</a>
            <a href="#">Professional</a>
            <a href="#">Trends</a>
            <a href="#">Surgery</a>
            <a href="#">Health care</a>
            <a href="#">Transport</a>
            <a href="#">Medical</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
